export default {
    methods: {
        brToLi(text) {
            const br = /<br *\/*>/ig;

            return br.test(text)
                ? '<ul><li>' + text.replaceAll(br, '</li><li>') + '</li></ul>'
                : text;
        }
    },
}
